import axios from 'axios';
import qs from 'qs';
import { MessageBox } from 'element-ui';
let pendingArr = [];
let cancelToken = axios.CancelToken;
let pendingHadnler = (flag, cancelFn)=>{
    let inx = pendingArr.indexOf(flag);
    if(inx > -1){
        if(cancelFn){
            cancelFn();
        }else{
            pendingArr.splice(inx,1);
        }
    }else{
        if(cancelFn){
            pendingArr.push(flag)
        }
    }
}

const instance = axios.create({
    baseURL: process.env.NODE_ENV === 'production' ? location.origin : 'http://chuanyinet.madridwine.cn',
    timeout: 60000,
    headers: {}
});
instance.interceptors.request.use(config=>{ 
    config.cancelToken = new cancelToken( cancelFn => {
        pendingHadnler( config.baseURL + config.url + '&' + config.method, cancelFn)
    })
    if(config.method === 'post'){
        config.data = qs.stringify(config.data,{ arrayFormat: 'brackets' })
    }
    return config
},error=>{
    return Promise.reject(error)
})
instance.interceptors.response.use(data=>{
    pendingHadnler(data.config.baseURL + data.config.url + '&' + data.config.method);
    if(data.status === 200){
        if(data.data.uptoken){
            return Promise.resolve(data.data)
        }
        if(data.data.status!=='success'){
           MessageBox.alert(data.data.msg)
           return Promise.reject(data)
        }
        return Promise.resolve(data.data)
    }
    MessageBox.alert(data.status)
    return Promise.reject(data)
},error=> {
    if (axios.isCancel(error)) {
        console.log("Request canceled", error.message);
    } else {
        pendingArr = [];
        return Promise.reject(error)
    }
    
})


export default instance;